import { useReducer } from 'react';

import { type IAction } from 'src/utils/ts-utilities';

const steps = [
  'unpaid-invoices', // Show unpaid invoices
  'show-plan-usage-warning', // Warn user about active plan usage
  'review-account-usage', // Prompt to review account usage
  'show-cancellation-prompt', // Emotional cancel prompt
  'show-downgrade-confirmation', // Final confirmation with downgrade warning
  'plan-downgrade-in-progress', // Downgrade is processing
  'discount-request', // Discount request
  'cancellation-success', // Cancellation success
  'keep-plan', // Keep plan
] as const;

enum ActionEnum {
  SET_STEP = 'set-step',
  SET_INITIAL_DATA = 'set-initial-data',
}

type IActionReducer =
  | IAction<ActionEnum.SET_INITIAL_DATA>
  | IAction<
      ActionEnum.SET_STEP,
      {
        step: (typeof steps)[number];
      }
    >;

type IState = {
  step: (typeof steps)[number] | null;
};

const initialState: IState = {
  step: null,
};

const reducer = (state: IState, action: IActionReducer): IState => {
  switch (action.type) {
    case ActionEnum.SET_STEP:
      return {
        ...state,
        step: action.payload.step,
      };

    case ActionEnum.SET_INITIAL_DATA:
      return initialState;
    default:
      return state;
  }
};

export const useCancellationPlanSlice = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const setStep = (step: (typeof steps)[number]) => dispatch({ type: ActionEnum.SET_STEP, payload: { step } });

  const setInitialData = () => dispatch({ type: ActionEnum.SET_INITIAL_DATA, payload: {} });

  return {
    ...state,
    setStep,
    setInitialData,
  };
};
